<template>
  <div>
    <section class="documentos container">
      <AlertaMsj :alerta-msj="alertaMsj" />
      <h2 class="text-center py-3">
        Plantillas Mensajes Frecuentes
      </h2>
      <div class="text-center">
        <mdb-btn
          color="primary"
          icon="file-medical"
          @click="abrirFormulario('Agregar')"
        >
          Agregar nuevo
        </mdb-btn>
      </div>
      <ul class="plantilla-list">
        <li
          v-for="plant in plantillas"
          :key="plant.id"
        >
          <Plantilla
            v-if="plant.name"
            :plantilla="plant"
          >
            <template v-slot:botones>
              <mdb-btn
                flat
                dark-waves
                icon="pen"
                title="Editar"
                class="mr-0"
                @click="abrirFormulario('Actualizar',plant)"
              />
              <mdb-btn
                flat
                dark-waves
                text="danger"
                icon="minus-circle"
                title="Eliminar"
                class="ml-0"
                @click="showConfirmation = true;plantilla=plant"
              />
            </template>
          </Plantilla>
        </li>
      </ul>
    </section>
    <!--
      Modal para agregar /
      modificar una plantilla
    -->
    <mdb-modal
      centered
      elegant
      :show="showForm"
      @close="showForm = false"
    >
      <mdb-modal-header>
        <mdb-modal-title>
          {{ plantillaFormTitle }} plantilla
        </mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <div class="container text-center">
          <form @submit.prevent="validateForm">
            <div class="row justify-content-around">
              <div class="col-12">
                <mdb-input
                  v-model="plantilla.name"
                  label="Nombre de la plantilla"
                  class="my-1"
                  outline
                  required
                />
              </div>
              <div class="col-12">
                <mdb-input
                  v-model="plantilla.content"
                  type="textarea"
                  label="Contenido de la plantilla"
                  class="my-2"
                  :rows="5"
                  outline
                  required
                />
              </div>
            </div>
            <div class="row justify-content-around">
              <mdb-btn
                class="order-2 order-sm-1"
                color="blue-grey"
                icon="times"
                type="button"
                @click="showForm = false"
              >
                Cancelar
              </mdb-btn>
              <mdb-btn
                class="order-1 order-sm-2"
                color="success"
                :icon="btnLabel.icon"
                :disabled="btnDisabled"
              >
                <font-awesome-icon
                  v-if="btnDisabled"
                  icon="circle-notch"
                  spin
                  size="lg"
                />
                {{ btnLabel.nombre }}
              </mdb-btn>
            </div>
          </form>
        </div>
      </mdb-modal-body>
    </mdb-modal>
    <!--
      Modal para confirmar la
      eliminación de una plantilla
    -->
    <mdb-modal
      class="be-bottom"
      direction="bottom"
      :show="showConfirmation"
      @close="showConfirmation = false"
    >
      <mdb-modal-body class="delete-document">
        <p class="my-2">
          ¿Está seguro que desea eliminar la plantilla
          <span class="font-weight-bold">{{ plantilla.name }}</span>?
        </p>
        <div class="buttons">
          <mdb-btn
            class="order-2 order-sm-1"
            color="blue-grey"
            icon="times"
            @click="showConfirmation = false"
          >
            Cancelar
          </mdb-btn>
          <mdb-btn
            class="order-1 order-sm-2"
            color="danger"
            icon="minus-circle"
            @click="templateDelete()"
          >
            Eliminar
          </mdb-btn>
        </div>
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>
<script>
import Plantilla from '../components/Plantilla.vue';
import {mdbModal, mdbModalHeader, mdbModalTitle,
  mdbModalBody, mdbBtn, mdbInput} from 'mdbvue';
import gql from 'graphql-tag';
import templateCreateWithTagGql from '@/graphql/templateCreateWithTag.gql';
import templateGql from '@/graphql/template.gql';
import templateUpdateGql from '@/graphql/templateUpdate.gql';
import templateDeleteGql from '@/graphql/templateDelete.gql';
import AlertaMsj from '@/components/AlertaMsj.vue';
export default {
  name: 'Plantillas',
  components: {
    AlertaMsj,
    Plantilla,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbBtn,
    mdbInput,
  },
  data() {
    return {
      showForm: false,
      showConfirmation: false,
      btnLabel: {},
      // Alert para el componente AlertaMsj
      alertaMsj: {
        content: '',
      },
      plantillaFormTitle: '',
      plantilla: {},
      plantillaTemp: {},
      plantillas: [],
      btnDisabled: false,
    };
  },
  methods: {
    abrirFormulario(btnLabel, item) {
      this.showForm = true;
      this.plantilla={};
      this.btnLabel.nombre = btnLabel;
      if (btnLabel == 'Agregar') {
        this.btnLabel.icon = 'file-medical';
        this.plantillaFormTitle = 'Agregar';
      } else {
        this.plantillaTemp=item;
        this.plantilla=JSON.parse(JSON.stringify(item));
        this.btnLabel.icon = 'redo-alt';
        this.plantillaFormTitle = 'Editar';
      }
    },
    validateForm(event) {
      event.target.classList.add('was-validated');
      if (!this.plantilla.name || !this.plantilla.content) {
        return this.alertaMsj = {
          content: 'Llene los campos requeridos',
          type: 'warning',
        };
      }
      if (this.btnLabel.nombre == 'Agregar') {
        this.templateCreate();
      } else {
        this.templateUpdate();
      }
    },
    templateDelete() {
      this.$apollo.mutate({
        mutation: gql`${templateDeleteGql}`,
        variables: {
          templateId: this.plantilla.id,
        },
      }).then((res) => {
        this.plantilla.name = false;
        this.showForm = false;
        this.alertaMsj = {
          content: 'La plantilla ha sido eliminada con éxito',
          type: 'success',
        };
      }).catch((error) => {
        this.showForm = false;
        this.alertaMsj = {
          content: 'Hubo un error al eliminar la plantilla',
          type: 'danger',
        };
      });
      this.showConfirmation = false;
    },
    templateCreate() {
      this.btnDisabled= true;
      this.btnLabel = {};
      this.$apollo.mutate({
        mutation: gql`${templateCreateWithTagGql}`,
        variables: {
          template: this.plantilla,
          tagName: 'Médicos',
        },
      }).then((res) => {
        this.plantillas.push(res.data.templateCreateWithTag);
        this.btnDisabled = false;
        this.showForm = false;
        this.alertaMsj = {
          content: 'La plantilla ha sido agregada con éxito',
          type: 'success',
        };
      }).catch((error) => {
        this.btnDisabled = false;
        this.showForm = false;
        this.alertaMsj = {
          content: 'Hubo un error al agregar plantilla',
          type: 'danger',
        };
      });
    },
    templateUpdate() {
      this.btnDisabled = true;
      this.btnLabel = {};
      this.$apollo.mutate({
        mutation: gql`${templateUpdateGql}`,
        variables: {
          name: this.plantillaTemp.name,
          template: {
            name: this.plantilla.name,
            content: this.plantilla.content,
          },
        },
      }).then((res) => {
        Object.assign(this.plantillaTemp, {...this.plantilla});
        this.btnDisabled = false;
        this.showForm = false;
        this.alertaMsj = {
          content: 'La plantilla ha sido actualizada con éxito',
          type: 'success',
        };
      }).catch((error) => {
        this.btnDisabled = false;
        this.showForm = false;
        this.alertaMsj = {
          content: 'Hubo un error al editar plantilla',
          type: 'danger',
        };
      });
    },
  },
  apollo: {
    plantillas() {
      return {
        query: gql`${templateGql}`,
        update: (data) => data.Template,
      };
    },
  },
};
</script>
<style lang="scss">
  .be-bottom .modal-dialog {
    bottom: 0;
    margin: 1.75rem auto 0;
    max-width: 100%;
    position: fixed;
    width: 100%;

    .delete-document {
      align-items: center;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-around;

      .buttons {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
      }
    }
  }
</style>
